import { render, staticRenderFns } from "./TransformerTab.vue?vue&type=template&id=73c15c2f&scoped=true&"
import script from "./TransformerTab.vue?vue&type=script&lang=js&"
export * from "./TransformerTab.vue?vue&type=script&lang=js&"
import style0 from "./TransformerTab.vue?vue&type=style&index=0&id=73c15c2f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c15c2f",
  null
  
)

export default component.exports